import { MagazineCategory } from '../contexts/Magazine/enums';

interface MagazineCategoryMapper {
  [key: string]: MagazineCategory;
}

const magazineCategoryMapper: MagazineCategoryMapper = {
  'our-world': MagazineCategory.OurWorld,
  'my-life': MagazineCategory.MyLife,
  'your-city': MagazineCategory.YourCity,
};

const transformMagazineMagnoliaCategory = (
  category: string
): MagazineCategory => {
  return magazineCategoryMapper[category] ?? MagazineCategory.OurWorld;
};

export default transformMagazineMagnoliaCategory;
